"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusIconSrc = void 0;
const Error_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Error/Error.svg"));
const Warning_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Warning/Warning.svg"));
const Ok_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Ok/Ok.svg"));
const types_1 = require("../types");
const statusIconSrcMap = new Map([
    [types_1.ADD_TO_POLICY_RESULT_STATUS.success, Ok_svg_1.default],
    [types_1.ADD_TO_POLICY_RESULT_STATUS.failed, Error_svg_1.default],
    [types_1.ADD_TO_POLICY_RESULT_STATUS.warning, Warning_svg_1.default],
]);
const getStatusIconSrc = (status) => {
    return statusIconSrcMap.get(status) || '';
};
exports.getStatusIconSrc = getStatusIconSrc;
//# sourceMappingURL=getStatusIconSrc.js.map